export enum TipoConciliacaoBancaria {
    CREDITO = "CREDITO",
	DEBITO = "DEBITO"
}